import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook for Android back navigation that works with native Android back button handling
 * This hook provides React-level navigation logic that works alongside the native Android handler
 */
export function useAndroidBackNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we're on Android
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    if (!isAndroid) {
      return; // Only apply on Android
    }

    console.log('✅ Android back navigation hook initialized');

    // This hook now works in conjunction with the native Android back button handler
    // The native handler will call this logic when appropriate
    
    // No need to add event listeners here since the native Android handler
    // will manage the back button press and call appropriate navigation logic
    
  }, [navigate, location]);

  // Return navigation functions that can be used by the native Android handler
  return {
    canGoBack: () => {
      // Check if we can navigate back in the React app
      return window.history.length > 1;
    },
    goBack: () => {
      // Navigate back in the React app
      navigate(-1);
    },
    isOnMainPage: () => {
      // Check if we're on the main dashboard/page
      return location.pathname === '/' || location.pathname === '/dashboard';
    },
    getCurrentPath: () => {
      // Get the current path for debugging
      return location.pathname;
    }
  };
}
